"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var overview_field_type_1 = require("../model/overview-field-type");
var overview_card_type_1 = require("../model/overview-card-type");
exports.OVERVIEW_CARD_TYPES = [
    { id: overview_card_type_1.OverviewCardType.MAIN_CARD, messageKey: 'ejustice_overview_main_card' },
    { id: overview_card_type_1.OverviewCardType.GROUP_CARD, messageKey: 'ejustice_overview_group_card' },
    { id: overview_card_type_1.OverviewCardType.SINGLE_ENTITY_CARD, messageKey: 'ejustice_overview_single_entity_card' },
    { id: overview_card_type_1.OverviewCardType.CUSTOM_CARD, messageKey: 'ejustice_overview_custom_card' },
];
exports.OVERVIEW_PORTFOLIO_FIELD_TYPES = [
    { id: overview_field_type_1.OverviewPortfolioFieldType.FIELD, messageKey: 'ejustice_overview_portfolio_entity_field' },
    { id: overview_field_type_1.OverviewPortfolioFieldType.CALCULATION, messageKey: 'ejustice_overview_portfolio_custom_field' },
    { id: overview_field_type_1.OverviewPortfolioFieldType.COMPONENT, messageKey: 'ejustice_overview_portfolio_component_field' },
    { id: overview_field_type_1.OverviewPortfolioFieldType.AGGREGATE, messageKey: 'ejustice_overview_portfolio_aggregate_field' },
];
//# sourceMappingURL=config-constants.js.map